export default "__VITE_ASSET__DWi3rRPl__"